import { CameraInfo, InventoryAction } from '@scaleaq/sitecontrol-lib';

/**
 * Checks if the camera has any camera control actions (tilt or pan)
 * The camera controls panel requires at least one of these actions to be useful
 */
export const hasCameraControlActions = (camera: CameraInfo): boolean => {
  if (!camera) return false;
  return (
    camera.privateActions.includes(InventoryAction.CameraTiltUp) ||
    camera.privateActions.includes(InventoryAction.CameraTiltDown) ||
    camera.privateActions.includes(InventoryAction.CameraPanLeft) ||
    camera.privateActions.includes(InventoryAction.CameraPanRight)
  );
};

export const hasCameraZoomActions = (camera: CameraInfo): boolean => {
  if (!camera) return false;
  return (
    camera.privateActions.includes(InventoryAction.CameraZoomIn) ||
    camera.privateActions.includes(InventoryAction.CameraZoomOut)
  );
};
